module.exports = __webpack_public_path__ + "static/media/myMapsActive.eaa15093.png";